import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorPledgedEth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 20.25a8.25 8.25 0 0 0 7.566-11.544.75.75 0 1 1 1.375-.6l.044.102A9.723 9.723 0 0 1 21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25a.75.75 0 0 1 0 1.5 8.25 8.25 0 1 0 0 16.5Z"
    />
    <path
      fill="#F7A600"
      d="M17.75 2.75a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5ZM8.651 12.56a.4.4 0 0 1 0-.392l3.106-5.545a.4.4 0 0 1 .698 0l3.107 5.545a.4.4 0 0 1 0 .392l-3.107 5.545a.4.4 0 0 1-.698 0L8.65 12.559Zm2.064.615 1.391 2.484 1.442-2.574-.992.496a1.15 1.15 0 0 1-1.029 0l-.812-.406Zm2.73-1.716-1.339-2.39-1.367 2.441 1.302.651 1.404-.702Z"
    />
  </svg>
);
export default SvgTwoColorPledgedEth;
